import { DefaultTemplate } from "components/modal/templates";
import React from "react";

export default class ForwardingOrderCarChangeModal extends DefaultTemplate {
    close = () => {
        const { actions, close } = this.props;
        actions.cancel?.();
        this.setState({ isLoading: false });
        return close();
    };

    renderHeader = () => {
        const { title } = this.props;
        return (
            <div className="modal-window__header">
                <div className="modal-window__header-title">{title}</div>
                <div className="close close--sm" onClick={this.close} />
            </div>
        );
    };

    renderBody = () => {
        const withCloseAction = (action) => {
            action();
            this.props.close();
        };
        return (
            <div>
                <p>По заявке отправлен запрос обратного рейса, при смене машины запрос нужно обновить или удалить.</p>
                <div className="d-flex mb-3 justify-content-center">
                    <div
                        className="btn btn-sm btn-brand mr-2"
                        onClick={() => withCloseAction(this.props.actions.update)}
                    >
                        Обновить
                    </div>
                    <div className="btn btn-sm btn-danger" onClick={() => withCloseAction(this.props.actions.delete)}>
                        Удалить
                    </div>
                </div>
            </div>
        );
    };
}
